module.exports = __webpack_public_path__ + "static/img/subcontract2.e3ad7bc4.png";